// Edit Preferences mock data (approved HTML:
// 15-Edit-Preferences-Consistency-Review-v5.html). Full ordered methods
// with explicit conversation override. Permission + suppression gates
// stay authoritative. No fallback channel is silently selected.

export type MethodKey = 'text' | 'phone' | 'email' | 'chat';

export interface ContactMethod {
  key: MethodKey;
  label: string;
  caption: string;
  permission: 'granted' | 'needed' | 'blocked';
  detail: string;
}

export const ALL_METHODS: ContactMethod[] = [
  {
    key: 'text',
    label: 'Text message',
    caption: '(615) 555-0148',
    permission: 'granted',
    detail: 'Preferred window 9 AM – 7 PM Central',
  },
  {
    key: 'email',
    label: 'Email',
    caption: 'sarah.mitchell@example.com',
    permission: 'granted',
    detail: 'Marketing opt-in confirmed in Klaviyo',
  },
  {
    key: 'phone',
    label: 'Phone call',
    caption: '(615) 555-0148',
    permission: 'granted',
    detail: 'Weekday callbacks only',
  },
  {
    key: 'chat',
    label: 'Live chat',
    caption: 'Website session',
    permission: 'needed',
    detail: 'Only when Sarah starts the chat',
  },
];

export const INITIAL_ORDER: MethodKey[] = ['text', 'email', 'phone'];

export const CUSTOMER_WORDS = 'Text is best, then email, then a phone call.';
export const SOURCE_OPTIONS = [
  'Inbound text conversation',
  'Phone call',
  'Email',
  'Live chat',
];
export const RECORDED_AT = '2026-10-06T11:26';

export const SCOPE_COPY = {
  ongoing: {
    heading: 'Update Sarah’s ongoing preference.',
    detail: 'This becomes her preferred order for future contact.',
  },
  conversation: {
    heading: 'Override only this conversation.',
    detail: 'Her ongoing preference stays unchanged after this work ends.',
  },
};
